import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { JPYs, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { WorkType } from '../common/enums';
import { BlankTypes } from '../common/Constant';

const IQ3KouteiBetsuKesanshiki_AutoBari = (props) => {
  const basicSetupTimeSec = props?.deviceMst?.details?.prepBasicTime;

  //装置の作業時間チャージ
  const mWorkHRate = props?.deviceMst.details?.charges.work;

  //装置の段階時間チャージ
  const mSetHRate = props?.deviceMst.details?.charges.prep;

  const dandoriAmt = (basicSetupTimeSec * mSetHRate) / 3600;

  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const [productionQuantityCoeff, setProductionQuantityCoeff] = useState(0);

  // 外周作業
  const [area, setArea] = useState(0);
  const [workTime, setWorkTime] = useState(0);
  const [processCount, setProcessCount] = useState(0);
  const [processTime, setProcessTime] = useState(0);
  const [processAmt, setProcessAmt] = useState(0);

  useEffect(() => {
    // レーザー工程入力情報取得
    let processInput = props?.autoBariData?.processInput?.filter((item) => item.processId == props?.processMst?.id)[0];
    // if (processInput) {
    //   setLaserProcessInput(processInput);
    // }

    calculateProcessing();
  }, [props?.autoBariData]);

  const calculateProcessing = () => {
    // 自動バリ工程入力情報取得
    let autoDeburProcessInput = props?.autoBariData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];

    // 面積
    let area = Number(autoDeburProcessInput?.details?.[0]?.area);
    setArea(area);
    /** 作業金額/時間 */
    // 作業時間｛加工時間 + 加工補正時間 * 加工補正係数)｝*	サイズ係数 * 回数
    let processCount = Number(autoDeburProcessInput?.details?.[0]?.count);
    setProcessCount(processCount);

    let workTime = calSagyoTime(props?.deviceMst, area);
    setWorkTime(workTime);

    let cSagyoTimeSec = workTime * processCount;
    cSagyoTimeSec = cSagyoTimeSec ? cSagyoTimeSec : 0;
    setProcessTime(cSagyoTimeSec);

    // 作業金額
    //　作業時間＊時間チャージ
    let cSagyoAmt = calSagyoAmt(cSagyoTimeSec);
    setProcessAmt(cSagyoAmt);
  };

  const calSagyoTime = (deviceMst, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 作業時間
    // 面積
    let areaThMaster = deviceMst?.details?.areaThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let workTime =
      areaThMaster?.length > 0
        ? deviceMst?.details?.workTimeThItems?.filter(
            (item) => item.no == areaThMaster[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : deviceMst?.details?.workTimeThItems[0]?.value;
    workTime = workTime ? workTime : 0;
    let processCof = getProductionQuantityCoeff(deviceMst);
    setProductionQuantityCoeff(processCof);
    workTime = workTime * processCof; // IQX_WEBEST-278 作業時間＊生産個数係数
    return workTime;
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.autoBariData?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const calSagyoAmt = (cSagyoTimeKonpoSec) => {
    // 作業金額
    // 作業時間
    let mWorkHTime = cSagyoTimeKonpoSec;
    let mWorkHTimeMin = mWorkHTime / 60;
    //　加工時間＊時間チャージ
    let cSagyoAmtKonpo = (mWorkHTimeMin * mWorkHRate) / 60.0;
    cSagyoAmtKonpo = Number.isFinite(cSagyoAmtKonpo) ? cSagyoAmtKonpo : 0;
    return cSagyoAmtKonpo;
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>
        </Col>
        <Col span={12} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
          </div>
        </Col>
        <Col span={8} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${basicSetupTimeSec} (${secondsToHms(basicSetupTimeSec)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${basicSetupTimeSec} × ${mSetHRate}) ÷ 3600 = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
          </div>
        </Col>
      </Row>

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      {isKakouOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工面積'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工時間 x サイズ係数 x 回数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工時間 x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工面積'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${workTime} x ${productionQuantityCoeff} x ${processCount} = ${processTime} (${secondsToHms(
                    processTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${processTime} × ${mWorkHRate} = ${JPYs.format(Math.round(processAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${area}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_AutoBari;
